<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Company-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.company') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Department-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.department') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Location-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.location') }}</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Meeting-room-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.meetingRoom') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Group-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.group') }}</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";

export default {
    page: {
        title: i18n.t("module.company"),
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: i18n.t("module.company"),
            items: [
                {
                    text: i18n.t("module.company"),
                    active: true,
                },
            ],
        }
    },
}
</script>
